import "/src/style/theme.scss"
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

AOS.init({
    offset: 0,
    duration: 1500,
    delay: 100,
    once: true,
});

Fancybox.bind("[data-fancybox]", {
    Hash: false,             // Root-level toggle still works
    hideScrollbar: true,     // This is correct at root level
    Carousel: {
        Arrows: {
            prevTpl: `
            <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.6738 6.36865H3.35162V8.60297H20.6738V6.36865Z" fill="#390F36"/>
                <path d="M8.15637 14.973L9.72168 13.408L3.79776 7.4865L9.72168 1.56496L8.15637 0L0.669266 7.48653L8.15637 14.973Z" fill="#390F36"/>
                </svg>`,
            nextTpl: `<svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M-0.00683594 6.36865H17.3154V8.60297H-0.00683594V6.36865Z" fill="#390F36"/>
                <path d="M12.5106 14.973L10.9453 13.408L16.8692 7.4865L10.9453 1.56496L12.5106 0L19.9977 7.48653L12.5106 14.973Z" fill="#390F36"/>
                </svg>`,
        },
        Thumbs: false,
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ["close"],  // Only show the Close button
            },
        },
    },
});


// Other
import "./helpers";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import Menu from "./modules/menu";
Menu().init();

import Popup from "./modules/popup";
Popup().init()

import Popup2 from "./modules/popup-2";
Popup2().init()

import AmenitiesPopup from "./modules/amenities-popup";
AmenitiesPopup().init()

import AmenitiesMap from "./modules/amenities-map";
AmenitiesMap().init()

import mapPopup from "./modules/map-popup";
mapPopup().init()

import planMap from "./modules/plan-map";
planMap().init()

import Slider from "./modules/slider";
Slider().init()

import GalleryFilters from "./modules/gallery-filters";
GalleryFilters().init()

import Video from "./modules/video";
Video().init()

import HeroAnimation from "./modules/hero-animation";
HeroAnimation().init()

import SmoothAnchor from "./modules/smooth-anchor";
SmoothAnchor().init()

import Cf7Form from "./modules/cf7-form";
Cf7Form().init()

// Templates

// Template parts
function resizeShape() {
    jQuery('.shape').each(function(index, element) {
        let $shape = jQuery(element);
        let $angle = $shape.find('.shape__angle');
        let offsetTop = $shape.offset().top;
        let scrollTop = jQuery(window).scrollTop();
        let scrollBottom = scrollTop + innerHeight/ ( innerWidth >= 960 ? 3 : 2);
        if ( offsetTop < scrollBottom ) {
            $angle.css({
                'scale': Math.max(1 - ((scrollBottom - offsetTop) / innerHeight / (innerWidth >= 960 ? 1 : .5)), innerWidth >= 960 ? .6 : .25)
            });
        }
    });
}
jQuery(document).ready(function($) {
    resizeShape();
})
jQuery(document).on('scroll', resizeShape);

// Pages